import { mailFrom } from '@/api/mail'
import { mapGetters } from 'vuex'
import Add from './add.dialog'
const columns = [
  {
    title: '',
    enTitle: 'System',
    width: 220,
    dataIndex: 'journal',
    slot: 'journal'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 200,
    dataIndex: 'name',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Email Address',
    width: 300,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    slot: 'actions'
  }
]
export default {
  components: { Add },
  data() {
    return {
      show: false,
      columns,
      inputData: {},
      dataSource: [],
      titleTab: [
        { title: 'System Email - General', statu: 1, scope: 'SYSTEM' },
        { title: 'System Email - Warming Up', statu: 2, scope: 'SYSTEM_WU' },
        { title: 'Journal Email - General', statu: 3, scope: 'JOURNAL' },
        { title: 'Journal Email - Warming Up', statu: 4, scope: 'JOURNAL_WU' }
      ],
      titleStatu: 'SYSTEM'
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      this.dataSource = await mailFrom.getAll({ scope: this.titleStatu })
    },
    edit(val) {
      this.inputData = val
      this.show = true
    },
    changeStatus(val) {
      this.titleStatu = val.scope
      this.getDetail()
    },
    confirm() {
      this.getDetail()
      this.show = false
    },
    cancel() {
      this.show = false
    }
  }
}
